import "./style/Header.css";

import bag_icon from "../assets/header/Group header-icon-1.png";
import notif_icon from "../assets/header/Group header-icon-2.png";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { BsSearch } from "react-icons/bs";
// import { useSelector } from "react-redux";

const Header = () => {
  // const state = useSelector((state) => state.default);
  // const [noci,set_noci] = useState(0);

  // useEffect(()=>{
  //   set_noci(state.CartData.length);
  // },[state.CartData.length])
  const nitfCount = 0;
  const productCount = 0;
  return (
    <div className="header">
      <Link to="/dashboard/cart" className="header-icon-container">
        <img src={bag_icon} alt="bag-icon" />
        {productCount ? (
          <div className="hic-badge hic-badge-bag">{productCount}</div>
        ) : null}
      </Link>
      <Link to="/dashboard/store">
        <div className="header-icon-container">
          <BsSearch style={{fontSize:"30px",color:"#2E81E8"}}/>
        </div>
      </Link>
    </div>
  );
};

export default Header;
